import { API_NAME, REDUX_STORE } from '@funnels/constants';
import {
  ProductPreferences,
  ProductPreferencesActionTypes,
  ProductPreferencesReducerState,
  SharedActionTypes,
} from '@funnels/types';

const initialState: ProductPreferencesReducerState = {
  data: [],
  error: null,
  loading: 0,
};

export default function productPreferencesReducer(
  state: ProductPreferencesReducerState = initialState,
  action: ProductPreferencesActionTypes | SharedActionTypes
): ProductPreferencesReducerState {
  switch (action.type) {
    case REDUX_STORE.SHARED_ACTION_TYPES.CLEAR_DATA:
      return {
        ...state,
        data: [],
      };
    case REDUX_STORE.SHARED_ACTION_TYPES.CLEAR_ERROR:
    case REDUX_STORE.PRODUCT_PREFERENCES.ACTION_TYPES.CLEAR_PRODUCT_PREFERENCES_ERROR:
      return {
        ...state,
        error: null,
      };
    case REDUX_STORE.PRODUCT_PREFERENCES.ACTION_TYPES.CREATE_PRODUCT_PREFERENCES:
      return {
        ...state,
        data: [...state.data, action.productPreferences],
        loading: state.loading + 1,
      };
    case REDUX_STORE.PRODUCT_PREFERENCES.ACTION_TYPES.CREATE_PRODUCT_PREFERENCES_SUCCESS:
      return {
        ...state,
        data: state.data.map((productPreferences) =>
          productPreferences.clientId === action.clientId
            ? { ...productPreferences, id: action.id }
            : productPreferences
        ),
        loading: state.loading - 1,
      };
    case REDUX_STORE.PRODUCT_PREFERENCES.ACTION_TYPES.DELETE_PRODUCT_PREFERENCES:
      return {
        ...state,
        data: state.data.filter((productPreferences) => productPreferences.clientId !== action.clientId),
        loading: state.loading + 1,
      };
    case REDUX_STORE.PRODUCT_PREFERENCES.ACTION_TYPES.DELETE_PRODUCT_PREFERENCES_SUCCESS:
      return {
        ...state,
        loading: state.loading - 1,
      };
    case REDUX_STORE.PRODUCT_PREFERENCES.ACTION_TYPES.FETCH_PRODUCT_PREFERENCES:
      return {
        ...state,
        data: [],
        loading: state.loading + 1,
      };
    case REDUX_STORE.PRODUCT_PREFERENCES.ACTION_TYPES.FETCH_PRODUCT_PREFERENCES_SUCCESS:
      return {
        ...state,
        data: action.productPreferences.map(
          (productPreferences) =>
            ({
              ...productPreferences,
              clientId: productPreferences.id,
            } as ProductPreferences)
        ),
        loading: state.loading - 1,
      };
    case REDUX_STORE.PRODUCT_PREFERENCES.ACTION_TYPES.UPDATE_PRODUCT_PREFERENCES:
      return {
        ...state,
        data: [
          ...state.data.map((productPreferences) =>
            productPreferences.clientId === action.productPreferences.clientId
              ? action.productPreferences
              : productPreferences
          ),
        ],
        loading: state.loading + 1,
      };
    case REDUX_STORE.PRODUCT_PREFERENCES.ACTION_TYPES.UPDATE_PRODUCT_PREFERENCES_SUCCESS:
      return {
        ...state,
        loading: state.loading - 1,
      };
    case REDUX_STORE.PRODUCT_PREFERENCES.ACTION_TYPES.CREATE_PRODUCT_PREFERENCES_FAIL:
    case REDUX_STORE.PRODUCT_PREFERENCES.ACTION_TYPES.DELETE_PRODUCT_PREFERENCES_FAIL:
    case REDUX_STORE.PRODUCT_PREFERENCES.ACTION_TYPES.FETCH_PRODUCT_PREFERENCES_FAIL:
    case REDUX_STORE.PRODUCT_PREFERENCES.ACTION_TYPES.UPDATE_PRODUCT_PREFERENCES_FAIL:
      return {
        ...state,
        error: {
          name: API_NAME.PRODUCT_PREFERENCES,
          message: action.message,
        },
        loading: state.loading - 1,
      };
    default:
      return state;
  }
}
